import React, { Component } from 'react';
import { config, postFrom } from '../../../../../../axios';
import { Form, Input, message, Button } from 'antd';
import { formatTime } from '../../../../../../utils/index';
import ModalDom from '../../../../../../components/Modal';
import TableDOM from '../../../../../../components/Table'

const { TextArea } = Input;

class APILog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiLogData: { // logo数据
        total: 0,
        current: 1,
        list: []
      },
      detailVisible: false,
      detailData: {},

    };
  }

  componentDidMount() {
    this.postApilogFindPage({ id: this.props.id, current: 1 });
  }

  postApilogFindPage = ({ id, current }) => { // 获取 apilog 记录
    const { apiLogData } = this.state
    const rowId = id || this.merchatId
    this.merchatId = rowId
    const data = { rowId, tableName: 'RentContract', current: current || apiLogData.current, pageSize: 10 }
    postFrom({
        url: config.API_apilog_findPage,
        data,
    }).then(res => {
        const { current, total, records } = res
        this.setState({
            apiLogData: {
                current,
                total,
                list: records
            }
        })
    }).catch(err => {
        message.error(err.message || '获取列表失败!')
    })
  }

  handleShowDetail = (record) => { // 打开详情
    this.setState({
        detailVisible: true,
        detailData: record
    })
  }

  handleCancel = () => {
    this.setState({
      detailVisible: false,
    })
  }

  handledetailCancel = () => { // 关闭详情
      this.setState({
          detailVisible: false
      })
  }

  render() {
    let {
      detailData,
    } = this.state;
    let { form: { getFieldDecorator } } = this.props;

    const { current, total, list } = this.state.apiLogData

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };

    return (
      <div>
        <div className="custom" style={{ paddingBottom: '20px' }}>
          <TableDOM
            columns={apilogColumns}
            data={list}
            loading={false}
            total={total}
            current={current}
            onChange={this.postApilogFindPage}
            onRow={(record) => {
              return {
                onClick: (event) => {
                  this.handleShowDetail(record);
                },
              };
            }}
          />
        </div>
        <ModalDom
            title="日志详情"
            visible={this.state.detailVisible}
            loading={false}
            width="660px"
            onOk={this.handleOk}
            footer={<Button onClick={this.handledetailCancel}>关闭</Button>}
            onCancel={this.handleCancel}
        >
            <Form>
                <Form.Item {...formItemLayout} label="接口url">
                    {getFieldDecorator('url', {
                        initialValue: detailData.url
                    })(
                        <Input
                            autoComplete={'off'}
                        />
                    )}
                </Form.Item>
                <Form.Item {...formItemLayout} label="接口参数">
                    {getFieldDecorator('params', {
                        initialValue: detailData.params
                    })(
                        <TextArea
                            autoComplete={'off'}
                        />
                    )}
                </Form.Item>
                <Form.Item {...formItemLayout} label="接口返回值">
                    {getFieldDecorator('response', {
                        initialValue: detailData.response
                    })(
                        <TextArea
                            autoComplete={'off'}
                        />
                    )}
                </Form.Item>
            </Form>
        </ModalDom>
      </div>
    );
  }
}

const apilogColumns = [
  { title: '接口名称', dataIndex: 'apiName' },
  { title: 'url', dataIndex: 'url' },
  {
    title: '调用时间',
    dataIndex: 'callTime',
    render(text) {
      if (!text) return '-';
      return formatTime(text);
    },
  },
];

export default Form.create()(APILog);



// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/APiLog/index.jsx